import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import React, { useEffect } from 'react'
import { FormControl, InputLabel, Link, MenuItem, Select } from '@mui/material';
import { useComparison } from '../../context/ComparisonContext';

export default function ProductCard(props) {
    const [variantSelect, setVariantSelect] = React.useState(null);
    const { apiBaseUrl, updateComparison } = useComparison();

    const variantName = props.variant.variant;
    const details = props.variant.details;
    const variants = props.variant.variants;

    const variant = variants.filter((variant) => variant.variantid == variantName)[0];

    const priceString = parseInt(variant.exshowroom, 10);
    const price = priceString.toLocaleString('en-IN');

    const publishing_date_complete = new Date(details.publishing_date);  // Convert the string into a Date object
    const publishing_date = publishing_date_complete.getFullYear();

    const url = `${apiBaseUrl}/${variant.make.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '').replace('maruti-suzuki', 'maruti')}/${variant.make.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '').replace('maruti-suzuki', 'maruti')}-${variant.modelslug}`;

    const variant_url = url


    useEffect(() => {

        setVariantSelect(variant.id);

    }, []);
    useEffect(() => {

        if (!variantSelect) {
            return;
        }

        const updatedItem = props.variant;

        const selectedVariant = variants.filter((variant) => variant.id == variantSelect)[0];
        updatedItem.variant = selectedVariant.variantid;

        updateComparison(updatedItem);

    }, [variantSelect]);

    const handleVariantChange = (event) => {
        setVariantSelect(event.target.value);
    };

    if (props.variant) {
        return (
            <Card sx={{ maxWidth: 345 }}>
                <CardMedia
                    component="img"
                    alt={`${details.img_url}`}
                    image={`https://api.tradebhp.com/images_v2/thumb/${details.img_url}`}
                />
                <CardContent sx={{ bgcolor: '#f9f9f9' }}>
                    <Typography gutterBottom variant="h5" component="h4" className='react-card-heading'>
                        {variant.make} {variant.model}
                    </Typography>
                    <Typography gutterBottom variant="body2" sx={{ color: 'text.secondary' }} component="div" className='react-card-variant'>
                        {variantName}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div" className='react-card-price'>
                        Price: {price}
                    </Typography>
                    <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label" className='react-select-label'>Variant</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select3"
                            value={variantSelect ?? ""}
                            label="Variant"
                            onChange={handleVariantChange}
                            className='react-select-placeholder-item'
                        >
                            {variants ? (variants.map(variant => (
                                <MenuItem value={variant.id} key={variant.id} className='react-select-item'>{variant.variantshortname}</MenuItem>
                            ))) : (<MenuItem value={0} className='react-select-item'>No variants</MenuItem>)}
                        </Select>
                    </FormControl>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-evenly',
                            borderRadius: 1,
                            bgcolor: '#f4f4f4',
                            mt: 2
                        }}
                    >
                        <Typography variant="body2" sx={{ color: 'text.secondary', padding: '8px' }} className='react-card-detail-item'>
                            {publishing_date}
                        </Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography variant="body2" sx={{ color: 'text.secondary', padding: '8px' }} className='react-card-detail-item'>
                            {variant.transmission_type}
                        </Typography>
                        <Divider orientation="vertical" flexItem />
                        <Typography align='center' variant="body2" sx={{ color: 'text.secondary', padding: '8px' }} className='react-card-detail-item'>
                            {variant.arai_mileage} {variant.concat_with_units}
                        </Typography>
                    </Box>
                </CardContent>
                <CardActions sx={{ bgcolor: '#D81517', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Link href={variant_url} color="inherit" sx={{ width: '100%' }}>
                        <Button size="small" sx={{ color: '#fff', width: '100%' }} className='react-card-view-btn'>
                            View Ofer
                        </Button>
                    </Link>
                </CardActions>
            </Card>
        )
    }
}
